import {
  ApiService,
  AuthorizedApiService,
  SPremiumAuthorizedApiService,
} from '../../../services/apiServices';
import { notification } from 'antd';
import { NavigationPath } from '../../../helpers/constants';
import { RESET_FORM, SET_LOGGED_USER, SET_LOGGED_SPREMIUM_USER } from './types';

export const registerUser = user => async dispatch => {
  try {
    AuthorizedApiService.post('auth/register', user)
      .then(res => {
        if (res.status !== 200) {
          if (
            !!res.response.data.message &&
            res.response.data.message !== 'genericError'
          )
            notification.error({
              message: res.response.data.message,
            });
          else
            notification.error({
              message: 'Invalid Register!',
            });
          return;
        }

        dispatch({
          type: RESET_FORM,
          payload: true,
        });
        notification.success({
          message: 'User registered!',
        });
        window.location = NavigationPath.USERS_ROUTE;
      })
      .catch(err => {
        notification.error({
          message: 'Invalid Register!',
        });
      });
  } catch (err) {
    console.log(err);
  }
};

export const loginUser = user => async dispatch => {
  try {
    ApiService.post('auth/login', user)
      .then(res => {
        const { status, data, response } = res;
        if (status !== 200) {
          if (
            !!response.data &&
            !!response.data.message &&
            response.data.message !== 'genericError'
          )
            notification.error({
              message: response.data.message,
            });
          else
            notification.error({
              message: 'Invalid Login!',
            });
          return;
        }

        if (!!data.status)
          window.location =
            NavigationPath.RESET_PASSWORD_ROUTE + `?status=${data.status}`;

        const { user, accessToken } = data;
        localStorage.setItem('adminToken', accessToken);
        localStorage.setItem('currentUser', JSON.stringify(user));
        setLoggedUser(user);
        notification.success({
          message: 'Logged in!',
        });
        user.role === 'Leasing admin'
          ? (window.location = NavigationPath.DASHBOARD_ROUTE)
          : (window.location = NavigationPath.WEB_CALCULATOR_ROUTE);
      })
      .catch(err => {
        if (
          !!err.response.data.message &&
          err.response.data.message !== 'genericError'
        )
          notification.error({
            message: err.response.data.message,
          });
        else
          notification.error({
            message: 'Invalid Login!',
          });
      });
  } catch (err) {
    console.log(err);
  }
};

export const setLoggedUser = user => async dispatch => {
  const user = JSON.parse(localStorage.getItem('currentUser'));
  if (user) {
    dispatch({
      type: SET_LOGGED_USER,
      payload: user,
    });
  }
};

export const logoutUser = () => async dispatch => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('currentSPremiumUser');
  localStorage.removeItem('spremiumAuthToken');
  dispatch({
    type: SET_LOGGED_USER,
    payload: null,
  });
  dispatch({
    type: SET_LOGGED_SPREMIUM_USER,
    payload: null,
  });
  notification.success({
    message: 'Logout success!',
  });
  window.location = NavigationPath.LOGIN_ROUTE;
};

export const loginSPremiumUser = user => async dispatch => {
  try {
    SPremiumAuthorizedApiService.post('auth/login', user)
      .then(res => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: 'Invalid Login!',
          });
          return;
        }
        const { user, accessToken } = data;
        localStorage.setItem('spremiumAuthToken', accessToken);
        localStorage.setItem('currentSPremiumUser', JSON.stringify(user));
        dispatch(setLoggedSPremiumUser());
        notification.success({
          message: 'Logged in!',
        });
      })
      .catch(err => {
        notification.error({
          message: 'Invalid Login!',
        });
      });
  } catch (err) {
    console.log(err);
  }
};

export const setLoggedSPremiumUser = () => async dispatch => {
  const user = JSON.parse(localStorage.getItem('currentSPremiumUser'));
  if (user) {
    dispatch({
      type: SET_LOGGED_SPREMIUM_USER,
      payload: user,
    });
  }
};

export const resetPassword = user => async dispatch => {
  try {
    ApiService.post('auth/reset-password', {
      email: user.email,
      oldPassword: user.oldPassword,
      newPassword: user.newPassword,
    })
      .then(res => {
        const { status, response } = res;
        if (status !== 200) {
          if (
            !!response.data.message &&
            response.data.message !== 'genericError'
          )
            notification.error({
              message: response.data.message,
            });
          else
            notification.error({
              message: 'Failed to change password!',
            });
          return;
        }
        window.location = NavigationPath.LOGIN_ROUTE;
      })
      .catch(err => {
        if (
          !!err.response.data.message &&
          err.response.data.message !== 'genericError'
        )
          notification.error({
            message: err.response.data.message,
          });
        else
          notification.error({
            message: 'Failed to change password!',
          });
      });
  } catch (err) {
    console.log(err);
  }
};
